<script lang="ts">
  import EmptyTable from "@shared/svelte/Components/EmptyTable.svelte";
  import { PlaidCustomization } from "@retailer/types/Plaid";
  import AddPaymentInstrument from "@retailer/svelte/Payments/AddPaymentInstrument.svelte";

  export let afterInstrumentAddSuccess: () => void;

</script>

<div class="fizz-bordered fizz-stack-32 fizz-inset-stretch-32">
  <EmptyTable iconType="CirclePayments" heading="There are no payment methods">
    <p class="fizz-stack-16">You must enter a payment method to pay invoices and set up auto pay</p>
    <div class="fizz-flex-row fizz-justify-center">
      <AddPaymentInstrument
        customization={PlaidCustomization.MultiSelect}
        afterSuccess={afterInstrumentAddSuccess}
      />
    </div>
  </EmptyTable>
</div>
